import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { deleteSection, sectionwhychooseListingData } from "../../../redux/cms/action";
import CommonPagination from '../../Common/Pagination/CommonPagination';
import DeleteCategory from "../Categories/DeleteCategory";
// import DeleteMembership from './DeleteMembership';

const SectionWhyChooseListing = () => {
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [params, setParams] = useState({
    section: 3,
    page: 1,
  });
  const section3data = useSelector(
    (state) => state?.reusableSlice?.getdatawhychoose
  );

  useEffect(() => {
    dispatch(sectionwhychooseListingData(params));
  }, [dispatch, params]);

  const addComponent = () => {
    navigate("/sectionwhychoooseadd");
  };
  const updateComponent = (id) => {
    navigate(`/sectionwhychoooseupdate/${id}`);
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteSection(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  return (
    <div className="p-3">

    <div className=" category-wrapper">
     <div className="d-flex align-items-center justify-content-between pb-3 ">
        <h4>Why Fatoora Need</h4>
      { section3data?.cms?.length>=6?"": <button
        className="background-button"
          onClick={() => {
            addComponent();
          }}
        >
          <span>Add</span>
        </button>}
      </div>
      <CardBody className="table-sec px-0">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Title</th>
              <th scope="col">Sub Title</th>
              <th scope="col">Image</th>
              <th scope="col">icon</th>
              <th scope="col" className="text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {section3data?.cms?.length > 0 ? (
              section3data?.cms?.map((item, index) => (
                <tr key={index}>
                  <td> {index + 1 + (params?.page - 1) * 10}</td>
                  <td>{item?.title} </td>
                  <td>{item?.sub_title} </td>

                  <td>
                    <img src={item?.image} className="img_styles"></img>
                  </td>
                  <td>
                    <img src={item?.icon} className="img_styles"></img>
                  </td>
                  <td>
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ columnGap: "10px" }}
                    >
                      <button
                        className="border-button"
                        onClick={() => updateComponent(item?.id)}
                      >
                        <span>Update</span>
                      </button>
                      <button
                        className="background-button"
                        onClick={() => {
                          setModal(true);
                          setCurrentComponent(item);
                        }}
                      >
                        <span>Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CardBody>
      <CommonPagination
          params={params}
          setParams={setParams}
          pagination_meta={section3data?.pagination_meta}
        />
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <DeleteCategory  modalTitle={"cms"}
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}></DeleteCategory>
      </Modal>
    </div>
    </div>
  );
};

export default SectionWhyChooseListing;
